import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { AnyObject } from 'yup/lib/types'
import { AMOUNT_VALIDATION_PATTERN } from 'utils/yupSchemas/createNameSchema'

export type FiatSendFormData = {
  // Basic send details
  paymentEntityType?: 'beneficiary' | 'contact'
  amount: string
  currencyCode: string
  beneficiaryReference?: string
  contactId?: string
  fee?: string
  paymentReference: string
  sourceWalletLsid: string
  transferDestination: string
  customerFee?: string
  paymentMethod?: string // Only EUR for now
  // Auth
  callbackUrl?: string
  challengeCode?: string
  twoFactorCode?: string
  // Additional fields
  achSameDay?: boolean
  beneficiaryVerificationId?: string
}

export type FiatSendFormKeys = keyof FiatSendFormData

type AmmountValdiationProps = {
  value: string
  ctx: yup.TestContext<AnyObject>
  t: TFunction<'translation', undefined>
}

export const validateAmount = ({ value, ctx, t }: AmmountValdiationProps) => {
  if (!value) {
    return ctx.createError({
      message: t('fieldIsARequiredField', {
        field: t('amount'),
        interpolation: { escapeValue: false },
      }),
    })
  }

  if (!AMOUNT_VALIDATION_PATTERN.test(value)) {
    return ctx.createError({
      message: t('formFields.errors.invalidAmount'),
    })
  }

  return true
}

export const fiatSendFormSchema = (t: TFunction<'translation', undefined>) => {
  return yup.object<Record<FiatSendFormKeys, yup.AnySchema>>({
    // Basic send details
    paymentEntityType: yup.string().notRequired().default('beneficiary'),
    contactId: yup.string().when('paymentEntityType', {
      is: 'contact',
      then: yup.string().required(),
      otherwise: yup.string().notRequired(),
    }),
    beneficiaryReference: yup.string().when('paymentEntityType', {
      is: 'beneficiary',
      then: yup.string().required(),
      otherwise: yup.string().notRequired(),
    }),
    amount: yup
      .string()
      .required()
      .test((value, ctx) => validateAmount({ value, ctx, t })),
    customerFee: yup
      .string()
      .notRequired()
      .test((value, ctx) => validateAmount({ value, ctx, t })),
    fee: yup.string().notRequired(),
    currencyCode: yup.string().required(),
    paymentReference: yup.string().required(),
    sourceWalletLsid: yup.string().required(),
    transferDestination: yup.string().required(),
    paymentMethod: yup.string().notRequired(),
    // Auth
    twoFactorCode: yup.string().notRequired(),
    challengeCode: yup.string().notRequired(),
    callbackUrl: yup.string().notRequired(),
    // Additional fields
    achSameDay: yup.boolean().notRequired().default(false),
    beneficiaryVerificationId: yup.string().notRequired(),
  })
}
